/**
 * Get avatar background color based on name
 * @param {string} name - User's full name
 * @returns {string} Tailwind CSS background color class
 */
export const getAvatarColor = (name) => {
  const colors = [
    "bg-blue-500",
    "bg-purple-500",
    "bg-green-500",
    "bg-orange-500",
    "bg-pink-500",
    "bg-indigo-500"
  ];
  const index = name.charCodeAt(0) % colors.length;
  return colors[index];
};

/**
 * Get initials from first and last name
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name
 * @returns {string} Uppercase initials (e.g., "JD")
 */
export const getInitials = (firstName, lastName) => {
  return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
};
